import { render, staticRenderFns } from "./detailHeart.vue?vue&type=template&id=18e4db5d&scoped=true"
import script from "./detailHeart.vue?vue&type=script&lang=js"
export * from "./detailHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4db5d",
  null
  
)

export default component.exports